import { get, post, put, upload } from './Tools';

const getAll = async (estatus = null) => {
  const url = estatus
    ? `${process.env.REACT_APP_SERVER}solicitud_documento/admin/listar?estatus=${estatus}`
    : `${process.env.REACT_APP_SERVER}solicitud_documento/admin/listar`;
  const response = await get(url);
  return response;
};

const getById = async (id) => {
  const response = await get(`${process.env.REACT_APP_SERVER}solicitud_documento/admin/detalle/${id}`);
  return response;
};

const updateEstatus = async (id, payload) => {
  const response = await put(`${process.env.REACT_APP_SERVER}solicitud_documento/admin/actualizar-estatus/${id}`, payload);
  return response;
};

const subirDocumento = async (payload) => {
  const response = await post(`${process.env.REACT_APP_SERVER}solicitud_documento/admin/subir-documento`, payload);
  return response;
};


const getEstadisticas = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}solicitud_documento/admin/estadisticas`);
  return response;
};

export {
  getAll,
  getById,
  updateEstatus,
  subirDocumento,
  getEstadisticas
};
